import { addError } from './logger';

const VIMEO_REGEX = /^https?:\/\/(www\.)?(vimeo\.com\/(video\/)?[0-9]+|player\.vimeo\.com\/video\/[0-9]+)(\?.*)?$/;
const YOUTUBE_REGEX = /^https?:\/\/(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]{11}(?:[?&].*)?$/;

export const isVimeoUrl = (url: string) => {
  return VIMEO_REGEX.test(url);
};

export const isYoutubeUrl = (url: string) => {
  return YOUTUBE_REGEX.test(url);
};

export const isVideoUrl = (url: string) => {
  return isVimeoUrl(url) || isYoutubeUrl(url);
};

export const extractVimeoVideoId = (videoUrl: string): string | null => {
  const vimeoMatch = videoUrl.match(/(?:player\.)?vimeo\.com\/(?:video\/)?([0-9]+)/);

  if (vimeoMatch) {
    return vimeoMatch[1];
  }

  return null;
};

export const getVimeoThumbnail = async (videoUrl: string): Promise<string | null> => {
  const videoId = extractVimeoVideoId(videoUrl);

  if (!videoId) {
    return null;
  }

  try {
    const response = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok || !response.headers.get('content-type')?.includes('application/json')) {
      return null;
    }

    const data = (await response.json()) as { thumbnail_url?: string | null };
    return data.thumbnail_url ?? null;
  } catch (error) {
    addError(error, { context: 'getVimeoThumbnail' });
    return null;
  }
};

export const extractYoutubeVideoId = (url: string): string | null => {
  const youtubeMatch = url.match(/youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})(?:[?&]|$)/);

  if (youtubeMatch) {
    return youtubeMatch[1];
  }

  const youtubeShortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})(?:[?&]|$)/);
  if (youtubeShortMatch) {
    return youtubeShortMatch[1];
  }

  return null;
};

export const getYoutubeThumbnail = (videoUrl: string): string | null => {
  const videoId = extractYoutubeVideoId(videoUrl);

  if (!videoId) {
    return null;
  }

  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
};
